<template>
    <ListHeader v-if="$route.name === 'Scripts'"
                :has-filters="false">
        <template v-slot:breadcrumb>
            <div id="breadcrumb">
                <ul>
                    <li>
                        <a class="navigate-router">
                            <span class="breadcrumb-level-1 navigate-to ap2-truncate"
                                  :style="getBulkActions.selectedItems.length > 0 ? 'color: var(--bulkActionsText)' : null">
                                Scripts
                            </span>
                        </a>
                    </li>
                </ul>
            </div>
        </template>
        <template v-slot:bulk-actions>
            <div v-if="getBulkActions.origin === 'scripts' && getBulkActions.selectedItems.length > 0" class="header-right">
                <ScriptsBulkActions/>
            </div>
        </template>
    </ListHeader>
</template>

<script>
    import {mapGetters} from "vuex";
    import search from '@/assets/images/magnifying-glass-solid.svg';
    import ListHeader from "@/components/commons/header/list-header";
    import ellipsisVertical from "@/assets/images/ellipsis-vertical-solid.svg";
    import play from "@/assets/images/play-solid.svg";
    import pause from "@/assets/images/pause-solid.svg";
    import ScriptsBulkActions from "@/components/commons/bulk-actions/scripts/index.vue";

    export default {
        name: 'ScriptsListHeader',
        components: {
            ScriptsBulkActions,
            ListHeader
        },
        computed: {
            ...mapGetters(['getFilterDrawer', 'getBulkActions', 'getSearchTerm']),
        },
        data() {
            return {
                searchTerm: null,
                ellipsisVertical: ellipsisVertical,
                search: search,
                play: play,
                pause: pause,
                selectedStatus: null,
                selectedTypes: []
            }
        },
        watch: {
            searchTerm: {
                handler: function (newVal) {
                    this.$store.dispatch('setSearchTerm', {searchTerm: newVal})
                }
            },
        },
    }
</script>